import React from 'react';
import theme from './UserInfoRow.module.scss';
import { UserIcon } from '@/components/Icons';

interface UserInfoRowProps {
    userId: number;
    displayName: string;
    profileName: string;
}

const UserInfoRow: React.FC<UserInfoRowProps> = ({ userId, displayName, profileName }) => {
    return (
        <div className={theme.container}>
            <UserIcon sizeInPx={28} userId={userId} />
            <div className={theme.text}>
                {displayName || ''}
                <span>{profileName || ''}</span>
            </div>
        </div>
    );
};

export default UserInfoRow;
